import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Droplets } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Droplets className="w-8 h-8 text-sky-500 animate-pulse" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
